import { useMutation } from "react-query";
import { postAgreement } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useAddAgreements = () => {
  //Add new carrier function
  return useMutation(postAgreement);
};
export default useAddAgreements;
